import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserAccountFacade } from '@spartacus/user/account/root';

import { ChartData, ChartOptions, ChartType } from 'chart.js';
import { SharedService } from 'src/app/shared/services/shared.service';
import { CustomInfluenzaService } from '../custom-influenza.service';

@Component({
  selector: 'app-flu-charts',
  templateUrl: './flu-charts.component.html',
  styleUrls: ['./flu-charts.component.scss'],
})
export class FluChartsComponent implements OnInit, OnDestroy {
  orderHistory: any = [];
  productsArray: any = [];
  totalDoses: any = 0;
  entriesForChart: any = [];
  chartTableArray: any = [];
  duplicateQuantityStatusArray: any = [];
  chartsBgColorArray: any = [];
  statusInChrtsDisplay: any = 'Shipped';

  public doughnutChartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          font: {
            size: 12,
          },
          usePointStyle: true,
        },
      },
    },
    maintainAspectRatio: true,
  };

  public chartColors: any[] = [{ backgroundColor: this.chartsBgColorArray }];

  public doughnutChartType: ChartType = 'doughnut';
  public doughnutChartLabels: string[] = [];
  public doughnutChartData: ChartData<'doughnut'> = {
    labels: this.doughnutChartLabels,
    datasets: [],
  };
  dosesInChartDisplay: any = 0;
  url: any;
  urlPath: any;
  chartSubscriber: any;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly ref: ChangeDetectorRef,
    private readonly sharedService: SharedService,
    private readonly user: UserAccountFacade,
    private readonly influenzaService: CustomInfluenzaService
  ) {}

  ngOnInit() {
    this.url = this.activatedRoute?.url;
    this.urlPath = this.url?._value[this.url?._value.length - 1]?.path;
    this.chartSubscriber = this.influenzaService.detailedReservation.subscribe(
      (res) => {
        if (res) {
          const data = this.sharedService.getSessionStorage('fluOverviewData');
          this.chartDataFormation(data);
        }
      }
    );
  }
  ngOnDestroy() {
    this.chartSubscriber?.unsubscribe();
  }

  chartDataFormation(data) {
    this.dosesInChartDisplay = 0;
    this.chartsBgColorArray = [];
    this.chartColors = [{ backgroundColor: this.chartsBgColorArray }];
    this.totalDoses = 0;
    this.orderHistory = [];
    this.entriesForChart = [];
    this.duplicateQuantityStatusArray = [];
    this.doughnutChartData = { labels: this.doughnutChartLabels, datasets: [] };
    this.doughnutChartLabels = [];
    this.chartTableArray = [];
    const dataSetArray = [];
    this.orderHistory.push(data);
    this.entriesForChart = this.orderHistory[0]?.entries;

    for (let i = 0; i < this.entriesForChart?.length; i++) {
      let status = '';
      let doses = 0;
      let TotalQuantity = 0;

      if (
        this.duplicateQuantityStatusArray.indexOf(
          this.entriesForChart[i]?.quantityStatus
        ) === -1
      ) {
        status = this.entriesForChart[i]?.quantityStatus;
        this.productsArray.push(this.entriesForChart[i]?.product);
        this.doughnutChartLabels.push(status);
        this.setChartColor(status, i);
        this.duplicateQuantityStatusArray.push(status);
        for (let j = 0; j < this.entriesForChart.length; j++) {
          if (status === this.entriesForChart[j]?.quantityStatus) {
            TotalQuantity += this.entriesForChart[j].quantity;
            const a =
              this.entriesForChart[j]?.quantity *
              this.entriesForChart[j]?.product?.quantityPerUnit;
            doses = doses + a;
          }

          j + 1 === this.entriesForChart.length
            ? this.settingTableDataArray(
                doses,
                TotalQuantity,
                dataSetArray,
                status
              )
            : '';
        }
      }

      i + 1 === this.entriesForChart.length
        ? this.chartFinalDataSet(dataSetArray)
        : '';
    }
  }

  setChartColor(status, index) {
    if (status === 'Shipped') {
      this.chartsBgColorArray.push('#34A760');
    } else if (status === 'Open') {
      this.chartsBgColorArray.push('#0A78CD');
    } else if (status === 'Cancelled') {
      this.chartsBgColorArray.push('#C4D0D3');
    } else if (status === 'Scheduled') {
      this.chartsBgColorArray.push('#003D7C');
    } else if (status === 'InProcess') {
      this.chartsBgColorArray.push('#A0C3E3');
    } else if (status === 'Completed') {
      this.chartsBgColorArray.push('#00501C');
    } else {
      this.chartsBgColorArray.push('#666');
    }
    if (index === this.entriesForChart.length) {
      this.chartColors = [
        {
          backgroundColor: this.chartsBgColorArray,
        },
      ];
    }
  }
  settingTableDataArray(dosesNum, TotalQuan, dataSetArr, statusData) {
    const chartObj = {
      doses: dosesNum,
      totalQuantity: TotalQuan,
      status: statusData,
    };
    chartObj.status === 'Shipped'
      ? (this.dosesInChartDisplay += chartObj.doses)
      : '';
    this.chartTableArray.push(chartObj);
    dataSetArr.push(dosesNum);
  }

  chartFinalDataSet(dataSetArr) {
    dataSetArr.forEach((dataRes, index) => {
      this.totalDoses += parseInt(dataRes);
      const dataset = {
        data: dataRes,
        label: this.doughnutChartLabels[index],
        backgroundColor: this.chartsBgColorArray[index],
      };
      this.doughnutChartData.datasets.push(dataset);
    });

    this.ref.detectChanges();
  }

  trackingProduct(url) {
    window.open(url, '_blank');
  }
}
